import { useState } from "react";
import EventDetailPage from "../Components/EventDetail";
import EventStatusBanner from "../Components/EventStatusBanner";
import TicketList from "../Components/TicketList";
import SpotifyPlaylistSection from "../Components/SpotifyPlaylistSection";
import { extractSpotifyPlaylistId } from "../helpers/spotifyPlaylist";

const EventDetails = () => {
  const [status, setStatus] = useState(null);
  const [event, setEvent] = useState(null);

  const isEventActive = status === "on";
  const spotifyPlaylistId = extractSpotifyPlaylistId(event?.spotifyPlaylistUrl);

  return (
    <div className="min-h-screen">
      <EventDetailPage setStatus={setStatus} onEventLoaded={setEvent} />

      {!isEventActive && <EventStatusBanner status={status} />}

      {isEventActive && (
        <div className="mx-auto w-full max-w-7xl px-4 pb-10">
          <TicketList />
          <SpotifyPlaylistSection spotifyPlaylistId={spotifyPlaylistId} />
        </div>
      )}
    </div>
  );
};

export default EventDetails;
